import React,{Component} from "react";
import { Layout} from 'antd';
import Header from "../../components/header";
import './finish.less'
const {Content } = Layout;

export default class Finish extends Component {

    state = {
        totalScore:0
    };

    toKnow = ()=> {
        this.props.history.push("/view");
        sessionStorage.setItem("pid","finish");
    };

    toCover = ()=> {
        sessionStorage.clear();
        this.props.history.replace("/cover");
    };

    componentDidMount = async () => {
        sessionStorage.setItem("testing","");
        this.setState({
            totalScore: sessionStorage.getItem("totalScore"),
            paperNo:sessionStorage.getItem("paperNo")
        });
    };

    render() {
        return (
            <Layout>
                <Header>Header</Header>
                <Content>
                    <div className='finish'>
                        <div className='score'>
                            <span className='num'>{this.state.totalScore}</span>分
                        </div>
                        <div>
                            <button className='analysis' onClick={this.toKnow}>查看解析</button>
                            <button className='out' onClick={this.toCover}>退出</button>
                        </div>
                    </div>
                </Content>
            </Layout>
        )
    }
}



